export default {
  name: 'custom_select_field',
  component_path: 'modules/procedures/blocks/BlockInputSelect'
}